/**
 * Einheitliche Fehlerbehandlung für die gesamte Anwendung
 */

/**
 * Zeigt eine Fehlermeldung an
 * @param {string} message - Fehlermeldung
 * @param {string} severity - Schweregrad ('error', 'warning', 'info', 'success')
 */
export const showError = (message, severity = 'error') => {
  if (window.showErrorNotification) {
    window.showErrorNotification(message, severity);
  } else {
    // Fallback falls ErrorNotification noch nicht geladen ist
    console.error(`[${severity.toUpperCase()}] ${message}`);
  }
};

/**
 * Behandelt API-Fehler einheitlich
 * @param {Error} error - Fehler-Objekt
 * @param {string} context - Kontext für die Fehlermeldung
 * @param {Function} onError - Optional: Callback-Funktion bei Fehler
 */
export const handleApiError = (error, context = '', onError = null) => {
  const contextMessage = context ? ` ${context}` : '';
  console.error(`API-Fehler${contextMessage}:`, error);
  
  // Fehlermeldung wird bereits von catchFuntion in api.js angezeigt
  // Hier nur für zusätzliches Logging und optionalen Callback
  
  if (onError && typeof onError === 'function') {
    onError(error);
  }
  
  return Promise.reject(error);
};
